// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n._18zr12x7{padding-inline:var(--ds-space-075,6px)}._18m915vq{overflow-y:hidden}\n._1reo15vq{overflow-x:hidden}\n._1tke28de{min-height:3.7rem}\n._ca0qu2gc{padding-top:var(--ds-space-100,8px)}\n._n3td12x7{padding-bottom:var(--ds-space-075,6px)}", ""]);
// Exports
module.exports = exports;
